import { render, staticRenderFns } from "./ViewPlotDetails400.vue?vue&type=template&id=7049d6b8"
import script from "./ViewPlotDetails400.vue?vue&type=script&lang=ts"
export * from "./ViewPlotDetails400.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports